import {i18n} from '@/plugins/i18n'

export const transmitType = {
    debit: 1,
    credit: 2,
};

export const transmitTypeStr = {
    debit: i18n.t('label.debit'),
    credit: i18n.t('label.credit'),

    get(type) {
        let type_str = null;

        Object.keys(transmitType).forEach(item => {
            if (transmitType[item] === type) {
                type_str = transmitTypeStr[item];
            }
        });

        return type_str;
    }
};
